import { useQuery } from '@tanstack/react-query';
import instance from '@src/api/axiosInstance';
import { trackQueryError } from '@src/utils/sensor/apptracker';
import { get } from 'lodash';

export const CustomerService = 'Customer Service';
export const Developer = 'Developer';
export const Admin = 'Admin';

const useUser =  () => {
  const { data, error, isLoading } = useQuery(['nav', 'user', 'profile'],
    async () => {
      const res =  await instance.get('/user/profile');
      return get(res, 'data', {});
    }, {
    retry: 1,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    notifyOnChangeProps: ['data', 'isError', 'isLoading'],
    onError: (err) => {
      trackQueryError({ type: 'nav-user-profile', err });
    },
  });
  return {
    data,
    error,
    loading: isLoading || !data,
  };
};

export const isAdmin = (user) => {
  return user.role === Admin;
}

export const isCustomerService = (user) => {
  return user.role === CustomerService;
}

export const isDeveloper = (user) => {
  return user.role === Developer;
}


export default useUser;
